<template>
  <BaseDialog
    v-if="loadComponent"
    v-model="dialogActive"
    v-bind="{ ...dialogProps }"
    :dismissable="false"
    has-cancel
    disable-close-after-continue
    :title="dialogTitle"
    :fullscreen="fullscreen"
    @continue="submit"
    @click:close="dialogActive = false"
  >
    <template #content>
      <component
        v-model="formData"
        :is="form"
        :action="action"
        :customResource="customResource"
        :initialData.sync="allInitialData"
        v-bind="formProps"
        is-dialog
        @validate="handleValidate"
      />
    </template>
  </BaseDialog>
</template>

<script>
import { mapActions } from 'vuex';
import form from '@/mixins/form';

export default {
  mixins: [form],
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    dialogTitle: {
      type: String,
      required: false,
    },
    fullscreen: {
      type: Boolean,
      default: false,
    },
    dialogProps: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formData: undefined,
    };
  },
  computed: {
    dialogActive: {
      get() {
        return this.dialog;
      },
      set(val) {
        if (!val) this.resetMessages();
        this.$emit('update:dialog', val);
      },
    },
  },
  watch: {
    dialog: {
      immediate: true,
      async handler(val) {
        if (val) {
          this.initialise();
        } else {
          this.loadComponent = false;
          if (this.action == 'edit') this.formData = undefined;
        }
      },
    },
  },
  methods: {
    ...mapActions('message', ['resetMessages']),
    async submit() {
      try {
        await this.executeServiceAction(this.formData);
        if (this.object) {
          this.formData = undefined;
          this.dialogActive = false;
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
